document.addEventListener("DOMContentLoaded", function () {
  const searchIcon = document.querySelector(".icon-search");
  const searchFormContainer = document.getElementById("search-form-container");

  // Toggle visibility of the search form
  searchIcon.addEventListener("click", function () {
    searchFormContainer.classList.toggle("tw-hidden");
    searchFormContainer.classList.toggle("tw-block");
  });
  
  // Recalculate positions on window resize
  //window.addEventListener('resize', updatePositions);
});